import { type ReactNode, useEffect, useState } from 'react';
import { useCheckAuth } from 'ra-core';
import { useNavigate } from 'react-router-dom';

export function AuthGuard({ children }: { children: ReactNode }) {
    const checkAuth = useCheckAuth();
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        checkAuth({})
            .then(async () => {
                const token = localStorage.getItem('auth_token');
                if (token) {
                    try {
                        const res = await fetch('/api/auth/user', {
                            headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
                        });
                        if (res.ok) {
                            const user = await res.json();
                            localStorage.setItem('auth_user', JSON.stringify(user));
                        }
                    } catch {
                        // Continuer avec les données en cache si le réseau échoue
                    }
                }
                setChecked(true);
            })
            .catch(() => navigate('/login', { replace: true }));
    }, [checkAuth, navigate]);

    if (!checked) {
        return (
            <div className="min-h-screen flex items-center justify-center text-gray-500">
                Chargement...
            </div>
        );
    }

    return <>{children}</>;
}
